var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.redraw,staticClass:"w3-center"},[(_vm.isReady)?_c('img',{staticStyle:{"margin-left":"0px","margin-top":"0px","margin-bottom":"0px"},style:(_vm.size),attrs:{"src":_vm.displayImage},on:{"error":_vm.imageError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }